<template>
  <transition name="fade">
    <div v-if="toast" :key="toast.key" class="rqa_toast" dir="rtl" role="status" aria-live="polite">
      <p class="rqa_toast_text"><span class="rqa_toast_title">{{ title }}</span><template v-if="toast.text">: {{ toast.text }}</template></p>
      <div class="rqa_toast_actions">
        <button type="button" class="button is-small is-info" @click="open">פתיחה</button>
        <button type="button" class="button is-small is-white" @click="dismiss">סגירה</button>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { SYSTEM_NOTE_TAG, KIND_SYSTEM_NOTE } from '@/utils/recruiterQaFormat'

const TOAST_AUTO_HIDE_MS = 20000

const TOAST_TITLES = {
  answered: 'התקבלה תשובה מהמערכת',
  needs_input: 'המערכת צריכה הבהרה',
  needs_human: 'השאלה הועברה להראל'
}

export default {
  name: 'RecruiterQaToast',
  data () {
    return { timer: null }
  },
  computed: {
    ...mapGetters('recruiterQa', { toast: 'currentToast' }),
    // Always the ordinary system wording: no management titles, whatever the
    // notification kind (INSTRUCTION_SPEC (d)).
    title () {
      // A system note (e.g. ticket transferred to you) is not an answer: use its own tag.
      if (this.toast && this.toast.kind === KIND_SYSTEM_NOTE) return SYSTEM_NOTE_TAG
      return (this.toast && TOAST_TITLES[this.toast.status]) || TOAST_TITLES.answered
    }
  },
  watch: {
    toast: {
      immediate: true,
      handler (next, prev) {
        if (next && prev && next.key === prev.key) return
        this.clearTimer()
        if (next) this.timer = setTimeout(this.dismiss, TOAST_AUTO_HIDE_MS)
      }
    }
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    ...mapActions('recruiterQa', ['dismissToast', 'openFromToast']),
    clearTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    dismiss () {
      this.clearTimer()
      this.dismissToast()
    },
    open () {
      this.clearTimer()
      if (this.toast) this.openFromToast({ rootId: this.toast.rootId })
    }
  }
}
</script>
<style scoped>
.rqa_toast {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 100002;
  width: 340px;
  max-width: calc(100% - 32px);
  box-sizing: border-box;
  background-color: #fff;
  color: #333;
  border-radius: 8px;
  border-right: 4px solid #3273dc;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 10px 14px;
  direction: rtl;
  text-align: right;
}
.rqa_toast_title {
  font-weight: bold;
}
.rqa_toast_text {
  font-size: 13px;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}
.rqa_toast_actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
.rqa_toast_actions .button {
  margin-left: 6px;
}
</style>
